import { blockResolver } from '@/core/component-resolver.service';
import { defineAsyncComponent } from 'vue';

// StoreProductDetail
import StoreProductDetailTile from './StoreProductDetailTile.vue';
import StoreContextOutletProductDetailTile from './StoreContextOutletProductDetailTile.vue';

// Store checkout async
const asyncStoreContextBasketTile = defineAsyncComponent(() => import(/* webpackChunkName: 'StoreContextBasket', webpackPrefetch: true */ './StoreContextBasketTile.vue'));
const asyncStoreContextCheckoutTile = defineAsyncComponent(() => import(/* webpackChunkName: 'StoreContextCheckout', webpackPrefetch: true */ './StoreContextCheckoutTile.vue'));
const asyncStoreContextReceiptTile = defineAsyncComponent(() => import(/* webpackChunkName: 'StoreContextReceipt', webpackPrefetch: true */ './StoreContextReceiptTile.vue'));
const asyncStoreContextReceiptHeroTile = defineAsyncComponent(() => import(/* webpackChunkName: 'StoreContextReceipt', webpackPrefetch: true */ './hero/StoreContextReceiptHeroTile.vue'));

blockResolver.register('StoreProductDetailTileModel', StoreProductDetailTile);
blockResolver.register('StoreContextBasketTileModel', asyncStoreContextBasketTile);
blockResolver.register('StoreContextCheckoutTileModel', asyncStoreContextCheckoutTile);
blockResolver.register('StoreContextReceiptTileModel', asyncStoreContextReceiptTile);
blockResolver.register('StoreContextReceiptHeroTileModel', asyncStoreContextReceiptHeroTile);
blockResolver.register('StoreOutletProductDetailTileModel', StoreContextOutletProductDetailTile);
